import React, { useState } from "react";

export const SurfSquadSelect = ({current}) => {
  const [selectedDate, setSelectedDate] = useState(current);

  const handleDateChange = (event) => {
    const selectedDate = event.target.value;
    setSelectedDate(selectedDate);
    // Redirect to the corresponding link based on the selected date
    window.location.href = `https://register.thetravelsquad.com/${selectedDate}`;
  };

  return (
    <div>
      <select className="w-full p-2 border rounded" id="dateSelect" value={selectedDate} onChange={handleDateChange} style={{ fontWeight: 'bold', marginLeft: -4}}>
        <option value="surfsquad-portugal">6th October - 13th October</option>
        <option value="surfsquad-portugal-2">13th October - 20th October</option>
      </select>
    </div>
  );
};
